import { render, staticRenderFns } from "./DepositPopup.vue?vue&type=template&id=36d79a57&scoped=true"
import script from "./DepositPopup.vue?vue&type=script&lang=js"
export * from "./DepositPopup.vue?vue&type=script&lang=js"
import style0 from "./DepositPopup.vue?vue&type=style&index=0&id=36d79a57&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d79a57",
  null
  
)

export default component.exports